import React, { Component, Fragment } from 'react';
import Modal from 'react-bootstrap/Modal';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import authService from '../../services/AuthService';
import api, { apiErrorHandler, apiResponseHandler } from '../../services/AxiosService';
import { isNullOrEmpty } from '../../helpers/LanguageHelpers';
import { alertPopup, apiErrorPopup } from '../../helpers/MessagePopup';

import copyIcon from '../../content/copy64.png';

import './Home.css';

 /*
* This displays a bootstrap modal that allows the user to modify assessment access permissions.
* Set the property show = true to show the modal, false to close it.
*/

class AssessmentAccessModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            assessmentId: this.props.assessmentId,
            assessmentOwnerId: 0,
            forLead: false,
            leadProfId: null,
            leadProfUsername: null,
            parentId: null,
            parentUsername: null,
            oldParentId: null,
            otherProfIds: null,
            otherProfNames: null,
            rater1Id: null,
            rater1Email: null,
            rater1Link: null,
            showRater1Buttons: false,
            rater2Id: null,
            rater2Email: null,
            rater2Link: null,
            showRater2Buttons: false,
            rater3Id: null,
            rater3Email: null, 
            rater3Link: null,
            showRater3Buttons: false,
            rater1SendLabel: "Send Email",
            rater2SendLabel: "Send Email",
            rater3SendLabel: "Send Email",
            leadParentSendLabel: "Send Email",
            otherSendLabel: "Send Email",
            readonly: false
        }
    
        this.needsSaved = false;
    }

    copyLink = (elmtId) => {
        /* Get the text field */
        var copyText = document.getElementById(elmtId);

        if (copyText.value.length == 0) {
            alertPopup('error', 'Then press this icon again to copy the link', 'Press "Get Link" First');
            return;
        }

        /* Select the text field */
        copyText.disabled = false;
        copyText.select();

        /* Copy the text inside the text field */
        document.execCommand("copy");

        window.getSelection().removeAllRanges();
        copyText.disabled = true;


        /* Alert the copied text */
        alertPopup('success', "Rater's login link copied to the clipboard");
    }

    closeHandler = (saveOnly) => {
        // validation checks
        let okToSave = true;
        let errorMessage = null;
        if (this.needsSaved) {
            if (!this.raterUsernameIsValid(1, this.state.rater1Id) || !this.raterUsernameIsValid(2, this.state.rater2Id) || !this.raterUsernameIsValid(3, this.state.rater3Id)) {
                okToSave = false;
                errorMessage = "One of the rater usernames is invalid.  These names cannot contain spaces.  Please check your rater names and try again.";
            }

            if (okToSave && (!this.cadeIdIsValid(this.state.leadProfId) || !this.cadeIdListIsValid(this.state.otherProfIds))) {
                errorMessage += " Your lead professional Id is invalid.  This Id is a number and respresents the CADE Id of your lead clinician.  Please recheck this Id and try again.";
                okToSave = false;
            }

            if (okToSave) {
                let url = "/assessment/" + this.state.assessmentId + "/accesspermissions";

                let accessModel = {
                    assessmentId: this.state.assessmentId,
                    assessmentOwnerId: this.state.assessmentOwnerId,
                    forLead: this.state.forLead,
                    leadProfId: this.state.leadProfId,
                    leadProfUsername: this.state.leadProfUsername,
                    parentId: this.state.parentId,
                    parentUsername: this.state.parentUsername,
                    oldParentId: this.state.oldParentId,
                    otherProfIds: this.state.otherProfIds,
                    otherProfNames: this.state.otherProfNames,
                    rater1Id: this.state.rater1Id,
                    rater1Email: this.state.rater1Email,
                    rater2Id: this.state.rater2Id,
                    rater2Email: this.state.rater2Email,
                    rater3Id: this.state.rater3Id,
                    rater3Email: this.state.rater3Email
                }

                api.post(url, accessModel,
                {
                    headers: {
                        Authorization: 'Bearer ' + authService.token
                    }
                })
                .then((response) => {
                    if (response.status == 200) {
                        if (!saveOnly) {
                            this.props.closeHandler();
                        }
                    }
                    else {
                        apiErrorPopup(apiResponseHandler(response));
                    };
                })
                .catch((error) => {
                    // Major problem - should not happen.  Back to login?
                    apiErrorPopup(apiErrorHandler(error));;
                });
            }
        }

        // Close if no errors and not save only
        if (okToSave) {
            if (!saveOnly) {
                this.props.closeHandler();
            }
        }
        else {
            alertPopup('error', errorMessage);
            return false;
        }
    }

    rater1NameChangeHandler = (e) => {
        this.setState({ rater1Id: e.target.value });
        this.needsSaved = true;
    }

    rater1EmailChangeHandler = (e) => {
        this.setState({ rater1Email: e.target.value });
        this.needsSaved = true;
    }

    rater2NameChangeHandler = (e) => {
        this.setState({ rater2Id: e.target.value });
        this.needsSaved = true;
    }

    rater2EmailChangeHandler = (e) => {
        this.setState({ rater2Email: e.target.value });
        this.needsSaved = true;
    }

    rater3NameChangeHandler = (e) => {
        this.setState({ rater3Id: e.target.value });
        this.needsSaved = true;
    }

    rater3EmailChangeHandler = (e) => {
        this.setState({ rater3Email: e.target.value });
        this.needsSaved = true;
    }

    idChangeHandler = (e) => {
        if (authService.isParentAccount) {
            this.setState({ leadProfId: e.target.value });
        }
        else {
            this.setState({parentId: e.target.value})
        }
        this.needsSaved = true;
    }

    usernameChangeHandler = (e) => {
        if (authService.isParentAccount) {
            this.setState({ leadProfUsername: e.target.value });
        }
        else {
            this.setState({ parentUsername: e.target.value });
        }
        this.needsSaved = true;
    }

    otherProfIdsChangeHandler = (e) => {
        this.setState({ otherProfIds: e.target.value });
        this.needsSaved = true;
    }

    cadeIdListIsValid = (idList) => {
        if (isNullOrEmpty(idList)) {
            return true;
        }

        let idListTrimmed = idList.replace(" ", "");
        let idListArray = idListTrimmed.split(",");
        let message = " invalid CADE user IDs:  ";
        let messageCount = 0;
        let isOK = true;
        for (let i = 0; i < idListArray.length; i++) {
            if (isNaN(idListArray[i])) {
                isOK = false;
                messageCount++;
                message += idListArray[i] + "    ";
            }
        }
        if (!isOK) {
            message = messageCount + message + " . A CADE user ID is an integer value and a list of these should be separated by commas.  For example: 12, 23, 4568";
            alertPopup('error', message);
            return false;
        }
        return true;
    }

    cadeIdIsValid = (id) => {
        if (isNullOrEmpty(id)) {
            // covers the non-entry case
            return true;
        }

        if (isNaN(id)) {
            alertPopup('error', "Invalid ID.  CADE user IDs are an integer value.  Please recheck your entry or contact your Licensed Professional.");
            return false;
        }
        return true;
    }

    raterUsernameIsValid = (which, username) => {
        if (isNullOrEmpty(username)) {
            // covers the non-entry case.
            return true;
        }

        if (username.indexOf(' ') != -1) {
            var message = "Rater " + which + " username cannot contain spaces or special characters.  For example, 'john smith' is not valid but 'johnsmith' is valid.  Please remove any whitespace from the username and try again";
            alertPopup('error', message);
            
            return false;
        }
        return true;
    }

    componentDidMount = () => {

        // This will get called on hiding as well!
        if (this.props.show == false) {
            return;
        }

        /*
         * Run a query to get the modal information for the given assessment
         */

        let url = "assessment/" + this.state.assessmentId + "/accesspermissions";
        api.get(url, {
            headers: {
                Authorization: 'Bearer ' + authService.token
            }
        })
            .then((response) => {
                if (response.status == 200) {
                    this.setState({
                        assessmentOwnerId: response.data.assessmentOwnerId,
                        rater1Id: response.data.rater1Id,
                        rater1Email: response.data.rater1Email,
                        rater2Id: response.data.rater2Id,
                        rater2Email: response.data.rater2Email,
                        rater3Id: response.data.rater3Id,
                        rater3Email: response.data.rater3Email,
                        forLead: response.data.forLead,
                        leadProfId: response.data.leadProfId,
                        leadProfUsername: response.data.leadProfUsername,
                        parentId: response.data.parentId,
                        parentUsername: response.data.parentUsername,
                        oldParentId: response.data.oldParentId,
                        otherProfIds: response.data.otherProfIds,
                        otherProfNames: response.data.otherProfNames
                    });
                }
            })
            .catch(error => {
                // Major problem - should not happen.  Back to login?
                apiErrorPopup(apiErrorHandler(error));;
            });
    }

    rater1SendWelcomeEmail = (e) => {
        if (this.rater1IsValid()) {
            if (this.needsSaved) {
                this.closeHandler(true);
            }

            let wtData = {
                toId: this.state.rater1Id + "__1",  // rater1Id is now just a username and the system will append the __N to make it easier for the user
                toEmail: this.state.rater1Email
            }
            this.setState({ rater1SendLabel: "..." });
            this.sendWelcomeEmail("rater1", "rater1", wtData);
        }
        else {
            alertPopup("error", "Please specify a name and valid email address for Rater 1");
        }
    }

    rater1IsValid = (justId) => {
        if (justId) {
            return (!isNullOrEmpty(this.state.rater1Id) && this.raterUsernameIsValid(1, this.state.rater1Id));
        }
        else {
            return (!isNullOrEmpty(this.state.rater1Id) && this.raterUsernameIsValid(1, this.state.rater1Id) && !isNullOrEmpty(this.state.rater1Email));
        }
    }

    rater2SendWelcomeEmail = (e) => {
        if (this.rater2IsValid()) {
            if (this.needsSaved) {
                this.closeHandler(true);
            }

            let wtData = {
                toId: this.state.rater2Id + "__2",
                toEmail: this.state.rater2Email
            }
            this.setState({ rater2SendLabel: "..." });
            this.sendWelcomeEmail("rater2", "rater2", wtData);
        }
        else {
            alertPopup("error", "Please specify a name and valid email address for Rater 2");
        }
    }

    rater2IsValid = (justId) => {
        if (justId) {
            return (!isNullOrEmpty(this.state.rater2Id) && this.raterUsernameIsValid(2, this.state.rater2Id));
        }
        else {
            return (!isNullOrEmpty(this.state.rater2Id) && this.raterUsernameIsValid(2, this.state.rater2Id) && !isNullOrEmpty(this.state.rater2Email));
        }
    }

    rater3SendWelcomeEmail = (e) => {
        if (this.rater3IsValid()) {
            if (this.needsSaved) {
                this.closeHandler(true);
            }

            if (!isNullOrEmpty(this.state.rater3Id) && this.raterUsernameIsValid(3, this.state.rater3Id) && !isNullOrEmpty(this.state.rater3Email)) {
                let wtData = {
                    toId: this.state.rater3Id + "__3",
                    toEmail: this.state.rater3Email
                }
                this.setState({ rater3SendLabel: "..." });
                this.sendWelcomeEmail("rater3", "rater3", wtData);
            }
        }
        else {
            alertPopup("error", "Please specify a name and valid email address for Rater 3");
        }
    }

    rater3IsValid = (justId) => {
        if (justId) {
            return (!isNullOrEmpty(this.state.rater3Id) && this.raterUsernameIsValid(3, this.state.rater2Id));
        }
        else {
            return (!isNullOrEmpty(this.state.rater3Id) && this.raterUsernameIsValid(3, this.state.rater2Id) && !isNullOrEmpty(this.state.rater3Email));
        }
    }

    leadParentSendWelcomeEmail = () => {
        if (authService.isParentAccount) {
            if (this.leadIsValid()) {
                if (this.needsSaved) {
                    this.closeHandler(true);
                }

                let wtData = {
                    toId: this.state.leadProfId,
                    toUsername: this.state.leadProfUsername
                }
                this.setState({ leadParentSendLabel: "..." });
                this.sendWelcomeEmail("lead", "leadParent", wtData);
            }
        }
        else {
            if (this.parentIsValid()) {
                if (this.needsSaved) {
                    this.closeHandler(true);
                }

                let wtData = {
                    toId: this.state.parentId,
                    toUsername: this.state.parentUsername
                }
                this.setState({ leadParentSendLabel: "..." });
                this.sendWelcomeEmail("parentassigned", "leadParent", wtData);
            }
        }
    }

    parentIsValid = () => {
        return (!isNullOrEmpty(this.state.parentId) && this.cadeIdIsValid(this.state.parentId) && !isNullOrEmpty(this.state.parentUsername));
    }

    leadIsValid = () => {
        return (!isNullOrEmpty(this.state.leadProfId) && this.cadeIdIsValid(this.state.leadProfId) && !isNullOrEmpty(this.state.leadProfUsername));
    }

    otherSendWelcomeEmail = () => {
        if (!isNullOrEmpty(this.state.otherProfIds))
        {
            let wtData = {
                toId: this.state.otherProfIds
            }
            this.setState({ otherSendLabel: "..." });
            this.sendWelcomeEmail("other", "other", wtData);
        }
    }

    sendWelcomeEmail = (which, whichLabel, welcomeTemplateData) => {
        welcomeTemplateData.welcomeType = which;
        welcomeTemplateData.providerId = this.props.providerId;
        welcomeTemplateData.fromId = authService.authenticatedUserId;
        welcomeTemplateData.patientFirstName = this.props.patientFn;
        welcomeTemplateData.patientLastName = this.props.patientLn;
        welcomeTemplateData.patientBirthDate = this.props.patientBd;

        whichLabel = whichLabel + "SendLabel";
        let url = "account/" + this.state.assessmentId + "/sendwelcome";
        api.post(url, welcomeTemplateData,
            {
                headers: {
                    Authorization: 'Bearer ' + authService.token
                }
            })
            .then((response) => {

                // Success is an OK (200) status code
                if (response.status == 200) {
                    this.setState({ [whichLabel]: "Sent!" });
                }
                else {
                    apiErrorPopup(apiResponseHandler(response));;
                    this.setState({ [whichLabel]: "Send Email" });
                };
            })
            .catch((error) => {
                // Major problem - should not happen.  Back to login?
                apiErrorPopup(apiErrorHandler(error));;
                this.setState({ [whichLabel]: "Send Email" });
            });
    }

    getRaterLink = (raterNum) => {
        let raterId = null;
        let raterEmail = null;
        switch (raterNum) {
            case "1":
                raterId = this.state.rater1Id;
                raterEmail = this.state.rater1Email;
                break;

            case "2":
                raterId = this.state.rater2Id;
                raterEmail = this.state.rater2Email;
                break;

            case "3":
                raterId = this.state.rater3Id;
                raterEmail = this.state.rater3Email;
                break;
        }

        if (isNullOrEmpty(raterId)) {
            var message = "You must provide a name for Rater " + raterNum + " in order to get a login link.  Names can contain numbers and letters only.";
            alertPopup('error', message);
            
            return;
        }

        let raterLinkData = {
            assessmentId: this.state.assessmentId,
            assessmentOwnerId: authService.authenticatedUserId,
            whichRater: raterNum,
            raterId: raterId,
            raterEmail: raterEmail
        }

        let url = "assessment/" + this.state.assessmentId + "/raterLink";
        api.post(url, raterLinkData,
            {
                headers: {
                    Authorization: 'Bearer ' + authService.token
                }
            })
            .then((response) => {
                var message;
                // Success is an OK (200) status code
                if (response.status == 200) {
                    switch (raterNum) {
                        case "1":
                            this.setState({ rater1Link: response.data.raterLink });
                            break;

                        case "2":
                            this.setState({ rater2Link: response.data.raterLink });
                            break;

                        case "3":
                            this.setState({ rater3Link: response.data.raterLink });
                            break;
                    }
                    message = "The login link for rater " + raterNum + " will be shown below.  CLICK THE ORANGE AND BLUE COPY ICON to the right of the text box to copy that link to your clipboard.";
                    alertPopup("success", message);
                }
                else {
                    apiErrorPopup(apiResponseHandler(response));;
                };
            })
            .catch((error) => {
                // Major problem - should not happen.  Back to login?
                apiErrorPopup(apiErrorHandler(error));;
            });
    }

    render() {
        let leadParentHeading = (authService.isParentAccount) ? "Grant Clinician Account Access" : "Grant CADE User Access";
        let leadParentSubheading = (authService.isParentAccount) ? "Lead Licensed Professional (Full Access)" : "CADE User (Full Access)";
        let displayLeadParentArea = (authService.isParentAccount || (authService.isClearClinician && authService.authenticatedUserId == this.state.assessmentOwnerId));
        let idValue = null;
        let unValue = null;
        if (authService.isParentAccount) {
            idValue = this.state.leadProfId;
            unValue = this.state.leadProfUsername;
        }
        else {
            idValue = this.state.parentId;
            unValue = this.state.parentUsername;
        }

        let rater1SendButtonDisabled = !this.rater1IsValid(false);
        let rater1LinkButtonDisabled = !this.rater1IsValid(true);
        let rater2SendButtonDisabled = !this.rater2IsValid(false);
        let rater2LinkButtonDisabled = !this.rater2IsValid(true);
        let rater3SendButtonDisabled = !this.rater3IsValid(false);
        let rater3LinkButtonDisabled = !this.rater3IsValid(true);

        let parentLeadButtonsDisabled = (authService.isParentAccount ? !this.leadIsValid() : !this.parentIsValid());

        return (
            <Fragment>
                <Modal
                    show={this.props.show}
                    onHide={this.closeHandler}
                    backdrop="static"
                    dialogClassName="home_accessModal"
                    className="modal"
                    onClick={(e) => { e.stopPropagation();}}
                >
                    <Modal.Header closeButton={true}>
                        <Modal.Title>Assessment {this.props.sCreateDate}<br />Grant Assessment Access<span className="home_AccessAutoSaveLabel">(changes auto-saved)</span></Modal.Title>
                    </Modal.Header>
                    
                    <Modal.Body>
                        <Form>
                            <h4>Grant Rater Access</h4>
                            <Container>
                                <h6>Rater 1</h6>
                                <Row>
                                    <Col sm={2}>
                                        <Form.Group controlId="rater1Id">
                                            <Form.Control id="rater1Id" as="input" type="text" maxLength={20} defaultValue={this.state.rater1Id} placeholder="Name" onKeyUp={this.rater1NameChangeHandler} onInput={this.rater1NameChangeHandler} disabled={this.state.readonly} />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={4}>
                                        <Form.Group controlId="rater1Email">
                                            <Form.Control id="rater1Email" as="input" type="text" defaultValue={this.state.rater1Email} placeholder="Email" onKeyUp={this.rater1EmailChangeHandler} onInput={this.rater1EmailChangeHandler}  disabled={this.state.readonly} />
                                        </Form.Group>
                                    </Col>
                                    
                                    <Col sm={3}>
                                        <Button variant="primary" size="md" onClick={this.getRaterLink.bind(this, "1")} disabled={this.state.readonly || rater1LinkButtonDisabled}>Get Link</Button>
                                    </Col>
                                    <Col sm={3}>
                                        <Button variant="secondary" size="md" onClick={this.rater1SendWelcomeEmail} disabled={this.state.readonly || rater1SendButtonDisabled}>{this.state.rater1SendLabel}</Button>
                                    </Col>
                                </Row>
                                <Row >
                                    <Col sm={12}>
                                        <input id="rater1Link" value={this.state.rater1Link} type="text" size={60} placeholder="Press Get Link if you want to send a rater login link in your own email" disabled></input>
                                        <span><img  style={{ width: 32 }} src={copyIcon} title="Copy to clipboard" alt="Copy to clipboard" onClick={this.copyLink.bind(this, "rater1Link")} /></span>
                                    </Col>
                                </Row>
                      
                                <h6>Rater 2</h6>
                                <Row>
                                    <Col sm={2}>
                                        <Form.Group controlId="rater2Id">
                                            <Form.Control id="rater2Id" as="input" maxLength={20} type="text" defaultValue={this.state.rater2Id} placeholder="Name" onKeyUp={this.rater2NameChangeHandler} onInput={this.rater2NameChangeHandler} disabled={this.state.readonly} />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={4}>
                                        <Form.Group controlId="rater2Email">
                                            <Form.Control id="rater2Email" as="input" type="text" defaultValue={this.state.rater2Email} placeholder="Email" onKeyUp={this.rater2EmailChangeHandler} onInput={this.rater2EmailChangeHandler} disabled={this.state.readonly} />
                                        </Form.Group>
                                    </Col>
                                    
                                    <Col sm={3}>
                                        <Button variant="primary" size="md" onClick={this.getRaterLink.bind(this, "2")} disabled={this.state.readonly || rater2LinkButtonDisabled}>Get Link</Button>
                                    </Col>
                                    <Col sm={3}>
                                        <Button variant="secondary" size="md" onClick={this.rater2SendWelcomeEmail} disabled={this.state.readonly || rater2SendButtonDisabled}>{this.state.rater2SendLabel}</Button>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={12}>
                                        <input id="rater2Link" value={this.state.rater2Link} type="text" size={60} placeholder="Press Get Link if you want to send a rater login link in your own email" disabled></input>
                                        <span><img style={{ width: 32 }} src={copyIcon} title="Copy to clipboard" alt="Copy to clipboard" onClick={this.copyLink.bind(this, "rater2Link")} /></span>
                                    </Col>
                                </Row>

                                <h6>Rater 3</h6>
                                <Row>
                                    <Col sm={2}>
                                        <Form.Group controlId="rater3Id">
                                            <Form.Control id="rater3Id" as="input" maxLength={20} type="text" defaultValue={this.state.rater3Id} placeholder="Name" onKeyUp={this.rater3NameChangeHandler} onInput={this.rater3NameChangeHandler} disabled={this.state.readonly} />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={4}>
                                        <Form.Group controlId="rater3Email">
                                            <Form.Control id="rater3Email" as="input" type="text" defaultValue={this.state.rater3Email} placeholder="Email" onKeyUp={this.rater3EmailChangeHandler} onInput={this.rater3EmailChangeHandler} disabled={this.state.readonly} />
                                        </Form.Group>
                                    </Col>
 
                                    <Col sm={3}>
                                        <Button variant="primary" size="md" onClick={this.getRaterLink.bind(this, "3")} disabled={this.state.readonly || rater3LinkButtonDisabled}>Get Link</Button>
                                    </Col>
                                    <Col sm={3}>
                                        <Button variant="secondary" size="md" onClick={this.rater3SendWelcomeEmail} disabled={this.state.readonly || rater3SendButtonDisabled}>{this.state.rater3SendLabel}</Button>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={12}>
                                        <input id="rater3Link" value={this.state.rater3Link} type="text" size={60} placeholder="Press Get Link if you want to send a rater login link in your own email" disabled></input>
                                        <span><img style={{ width: 32 }} src={copyIcon} title="Copy to clipboard" alt="Copy to clipboard" onClick={this.copyLink.bind(this, "rater3Link")} /></span>
                                    </Col>
                                </Row>
                            </Container>
                            <p></p>
                            {displayLeadParentArea &&
                            
                                <Fragment>
                                <h4>{leadParentHeading}</h4>
                                    <Container>

                                    <h6>{leadParentSubheading}</h6>
                                            <p className="home_LeadProfInstructions">CADE ID AND Username must be entered!</p>
                                    
                                        <Row>
                                            <Col sm={3}>
                                                <Form.Group controlId="leadProf">
                                                <Form.Control id="leadProf" as="input" type="text" value={idValue} placeholder="CADE ID" onKeyUp={this.idChangeHandler} onInput={this.idChangeHandler} disabled={this.state.readonly} /> 
                                                </Form.Group>
                                            </Col>
                                            <Col sm={5}>
                                                <Form.Group controlId="leadProfUn">
                                                <Form.Control id="leadProfUn" as="input" type="text" value={unValue} placeholder="CADE Username" onKeyUp={this.usernameChangeHandler} onInput={this.usernameChangeHandler} disabled={this.state.readonly} />
                                                </Form.Group>
                                            </Col>
                                        <Col sm={4}>
                                            <Button variant="primary" onClick={this.leadParentSendWelcomeEmail} disabled={this.state.readonly || parentLeadButtonsDisabled} block>{this.state.leadParentSendLabel}</Button>
                                            </Col>
                                        </Row>
                                        
                                    </Container>
                                </Fragment>
                            }

                        </Form>
                    </Modal.Body>
                </Modal>
            </Fragment>
        );
    }
}

export default AssessmentAccessModal;


// WEBPACK FOOTER //
// ./src/components/Home/AssessmentAccessModal.js